 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"09676caa","1":"1aee0214592a2888463f5ed0b1e023518ee6564e","2":"1bfc9850","3":"252f366e","4":"styles","5":"1297b6b15e8eb1a0c5e1b076180475fffe3b50b9","6":"dde381d7bc6a32797139dcba14686d261dd88fad","7":"291fbb6403be09c2c3c5c57b9874ffe25a99cea1","8":"95b64a6e","9":"65c4688f840c991cd718db57f477a9b7fb7e171f","10":"71a67a52","11":"95106bcc","12":"9bcf04df87c1ef8a80044426a6906fb33c045a18","13":"a3d3b99d02cf934bcb0e1bcaf220986d54508c90","14":"d7a25e952e08224adf5c3e221120666575d58a4a","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-js","21":"component---src-pages-account-js","22":"component---src-pages-cookie-policy-js","23":"component---src-pages-dispensaries-js","24":"component---src-pages-forgotpassword-js","25":"component---src-pages-index-js","26":"component---src-pages-login-js","27":"component---src-pages-privacy-policy-js","28":"component---src-pages-register-dispensary-confirm-js","29":"component---src-pages-register-dispensary-js","30":"component---src-pages-register-js","31":"component---src-pages-search-js","32":"component---src-pages-terms-of-use-js","33":"component---src-templates-dispensary-index-js","34":"component---src-templates-dispensary-listing-by-city-index-js","35":"component---src-templates-dispensary-listing-by-state-index-js","36":"component---src-templates-dispensary-menu-index-js","37":"component---src-templates-dispensary-reviews-index-js","38":"d676735c"}[chunkId]||chunkId) + "-" + {"0":"eb028d19d541a321f1e2","1":"009dbce2cbbb02d8b4dd","2":"e62aeea97d6a183cd851","3":"a1abcfcf5c1e6cb1d3dd","4":"c6fefb7f482bcee5f133","5":"f2fa47ed4c9be4647a05","6":"8706284a4ab4e597b8a6","7":"0aee72bfd7c364dbe5d8","8":"808d1b39b8fef6dbcb42","9":"748d6245ae66ab81222a","10":"60ebd32fe0921c767d92","11":"0ecd3eedd7d18d8e1594","12":"ba0472a904c77f803bce","13":"58ee502b91b090100ae8","14":"dc8e20519254aa5e916a","19":"5ba91d208abaa2d8e59e","20":"cf38574b38d51acf7937","21":"84c03ccd5e38227bfee1","22":"620dab18539a4e313046","23":"2b6a8f1e7c036fd7fe4b","24":"006a7133142a48899dbc","25":"25d98650bec7f58777ee","26":"4fbba0f47afcbe4ce298","27":"4c16fae573a88257c08c","28":"956ca0dce9ff6a00064b","29":"f40f43a418281b291499","30":"f6cc3f67222539c9dc17","31":"2a1cec13a1b2c8d62249","32":"580f6c8fcc2058aaa4cd","33":"d3252938e4c8e53ec7c2","34":"04a812b4515de8ad9e9d","35":"0322569d7d89c74f7c99","36":"b368ddf3b82c0312febd","37":"363e982daceba1ab923a","38":"705ef080bcd8d686005a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"09676caa","1":"1aee0214592a2888463f5ed0b1e023518ee6564e","2":"1bfc9850","3":"252f366e","4":"styles","5":"1297b6b15e8eb1a0c5e1b076180475fffe3b50b9","6":"dde381d7bc6a32797139dcba14686d261dd88fad","7":"291fbb6403be09c2c3c5c57b9874ffe25a99cea1","8":"95b64a6e","9":"65c4688f840c991cd718db57f477a9b7fb7e171f","10":"71a67a52","11":"95106bcc","12":"9bcf04df87c1ef8a80044426a6906fb33c045a18","13":"a3d3b99d02cf934bcb0e1bcaf220986d54508c90","14":"d7a25e952e08224adf5c3e221120666575d58a4a","19":"component---cache-caches-gatsby-plugin-offline-app-shell-js","20":"component---src-pages-404-js","21":"component---src-pages-account-js","22":"component---src-pages-cookie-policy-js","23":"component---src-pages-dispensaries-js","24":"component---src-pages-forgotpassword-js","25":"component---src-pages-index-js","26":"component---src-pages-login-js","27":"component---src-pages-privacy-policy-js","28":"component---src-pages-register-dispensary-confirm-js","29":"component---src-pages-register-dispensary-js","30":"component---src-pages-register-js","31":"component---src-pages-search-js","32":"component---src-pages-terms-of-use-js","33":"component---src-templates-dispensary-index-js","34":"component---src-templates-dispensary-listing-by-city-index-js","35":"component---src-templates-dispensary-listing-by-state-index-js","36":"component---src-templates-dispensary-menu-index-js","37":"component---src-templates-dispensary-reviews-index-js","38":"d676735c"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"ea629e774aa6b2cbe7e2","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
